import { Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { useRenderPDF } from './pdf/workers/useRenderPDF';

import { DownloadOptions } from '../../../../interfaces/DownloadOptions';
import { TenantNamesProps } from '../../../../interfaces/reportData';
import { ReportDataState } from '../../../../slices/reportDataSlice';

interface PreviewReportSectionProps {
  title: string;
  options: DownloadOptions;
  data: ReportDataState;
  userList: TenantNamesProps[];
}

const PreviewReportSection = ({
  title,
  options,
  data,
  userList,
}: PreviewReportSectionProps) => {
  const { url, loading, error } = useRenderPDF({
    title,
    options,
    data,
    userList,
  });

  if (loading)
    return (
      <Box
        flexGrow={1}
        height='100%'
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );

  if (error) {
    return (
      <Box flexGrow={1} height='100%' textAlign='center'>
        <Typography color='error'>
          <FormattedMessage defaultMessage='Error loading preview' />
        </Typography>
      </Box>
    );
  }

  return (
    <Box flexGrow={1}>
      <iframe
        src={url}
        title='Preview'
        width='100%'
        height='100%'
        referrerPolicy='no-referrer'
      />
    </Box>
  );
};

export default PreviewReportSection;
